import Vue from 'vue'
import moment from 'moment'
import get from 'lodash/get'
import FlightOrder from './flightOrder'
import { arrayMove, createUUID } from '@/utils/misc'
import { resolvePortLabels } from '@/utils/ports'
import i18t from '@/lang'

const AVG_PERSON_WEIGHT = 90

class Freight {
  id = createUUID()
  version = null

  code = null
  flightDate = null //ISO DATETIME
  ak = null
  bortType = null
  bort = null
  route = []

  flights = []
  removedOrders = []

  processData = {}

  createDate = null // ISO DATETIME
  createUserId = null
  updateDate = null // ISO DATETIME
  updateUserId = null

  getCode () {
    if (this.code != null) {
      return this.code
    }
    const m = moment
    const dateStr = moment.utc(this.flightDate).format('YYMM')
    const {ak, id} = this
    const idStr = this.isNew() ? '/[NEW]' : `/${id}`
    return `${ak}-${dateStr}${idStr}`
  }

  isNew () {
    return this.version == null || this.version === 0
  }

  hasFlights () {
    return (this.flights || []).filter(flight => !flight.isDeletePending).length > 0
  }

  getRouteLabel () {
    if (this.initialPortId) {
      const labels = resolvePortLabels(this.initialPortId)
      return `${labels.code} - ???`
    }
    return this.route.join(' - ')
  }

  /**
   * deprecated: don't use leg
   * @param leg
   * @returns {{flight: Flight, index: number}}
   */
  getFlightByLeg (leg) {
    const index = this.flights.findIndex(flight => flight.leg === leg)
    const flight = this.flights[index]
    return { flight, index }
  }
  getFlightByUuid (flightUuid) {
    const index = this.flights.findIndex(flight => flight.uuid === flightUuid)
    const flight = this.flights[index]
    return { flight, index }
  }
  getLastFlight () {
    const flights = this.flights.filter(flight => !flight.isDeletePending)
    const lastIndex = flights.length - 1
    if (lastIndex === -1) return null
    return flights[lastIndex]
  }

  addFlight (flightOptions) {
    const leg = (this.flights.length + 1)
    !flightOptions && (flightOptions = {})
    const flight = Flight.assign({ leg, ...flightOptions })
    flight.isNew = true
    this.flights.push(flight)
    this._renumerateLegs()
    this._rebuildRoute()
    return flight
  }

  /** deprecated: not used anymore */
  removeAllFlights () {
    const flightUuids = this.flights.map(flight => flight.uuid)
    flightUuids.forEach(flightUuid => {
      const removedFlight = this._removeFlightByUuid(flightUuid)
      document.MeridianVue.debug && console.log('removedFlight by uuid: %o', removedFlight)
    })
    document.MeridianVue.debug && console.log('freight#%o removedOrders: %o', this.id, this.removedOrders)
    this._rebuildRoute()
  }

  /**
   * Remove flight from flight
   * deprecated: don't use leg
   */
  removeFlightByLeg (leg) {
    const { flight } = this.getFlightByLeg(leg)
    return this.removeFlight(flight)
  }
  /**
   * Remove flight from flight
   */
  removeFlight (flight) {
    const removedFlight = this._removeFlightByUuid(flight.uuid)
    document.MeridianVue.debug && console.log('removedFlight flight: %o', removedFlight)

    this._renumerateLegs()
    this._rebuildRoute()
    return removedFlight
  }

  _removeFlightByUuid (flightUuid) {
    const { flight, index } = this.getFlightByUuid(flightUuid)
    this.flights.splice(index, 1)

    // !this.removedOrders && (this.removedOrders = [])
    // if (!flight.isNew) {
    //   this.removedOrders.push(...flight.orders)
    // } else {
    //   flight.orders.forEach(removedFlightOrder => {
    //     delete removedFlightOrder.flightUuid
    //   })
    // }
    return flight
  }

  /** deprecated: don't use leg */
  moveFlightTo (sourceLeg, targetLeg) {
    const { index } = this.getFlightByLeg(sourceLeg)
    arrayMove(this.flights, index, targetLeg - 1)
    this._renumerateLegs()
    this._rebuildRoute()
  }

  _rebuildRoute () {
    const routePortIds = this.flights.filter(flight => !flight.isDeletePending).reduce((acc, flight) => {
      const last = acc.slice(-1).pop()
      if (last !== flight.depPortId) {
        acc.push(flight.depPortId)
      }
      acc.push(flight.arrPortId)
      return acc
    }, [])
    const route = routePortIds.map(portId => resolvePortLabels(portId)).map(labels => labels ? labels.code : '???')
    this.route.splice(0, this.route.length, ...route)
  }

  _renumerateLegs () {
    let leg = 0
    this.flights.forEach(flight => {
      !flight.isDeletePending &&(leg++)
      flight.leg = leg
    })
  }

  /** deprecated: don't use leg, new orders is not used */
  addNewOrders (leg, flightOrders) {
    document.MeridianVue.debug && console.warn('TODO: [freight.addNewOrders]')
    const { flight } = this.getFlightByLeg(leg)
    flightOrders = Array.isArray(flightOrders) ? flightOrders : [flightOrders]
    const newOrders = []
    flightOrders.forEach(flightOrder => {
      const newOrder = flight.addNewOrder(flightOrder)
      newOrders.push(newOrder)
    })
    return newOrders
  }

  /** deprecated: don't use leg, removeOrders is not used */
  removeOrders (leg, flightOrderIds) {
    document.MeridianVue.debug && console.warn('TODO: [freight.removeOrders]')
    const { flight } = this.getFlightByLeg(leg)
    flightOrderIds = Array.isArray(flightOrderIds) ? flightOrderIds : [flightOrderIds]
    const removeOrders = []
    flightOrderIds.forEach(flightOrderId => {
      const removeOrder = flight.removeOrder(flightOrderId)
      removeOrder && removeOrders.push(removeOrder)
    })
    !this.removedOrders && (this.removedOrders = [])
    this.removedOrders.push(...removeOrders)
    return removeOrders
  }
  /** deprecated: don't use leg, moveOrder is not used */
  moveOrdersFrom (leg, flightOrders) {
    document.MeridianVue.debug && console.warn('TODO: [freight.moveOrdersFrom]')
    const { flight } = this.getFlightByLeg(leg)
    flightOrders = Array.isArray(flightOrders) ? flightOrders : [flightOrders]
    const moveOrders = []
    flightOrders.forEach(flightOrder => {
      const moveOrder = flight.moveOrderFrom(flightOrder.id)

      if (!moveOrder.isNew && !moveOrder.isMoveFromPending) {
        Vue.set(moveOrder, 'isMoveFromPending', {
          sourceFreightId: this.id,
          sourceFlightLeg: flight.leg,
          sourceFlightUuid: flight.uuid,
          sourceVersion: this.version
        })
      }
      moveOrders.push(moveOrder)
    })
    return moveOrders
  }
  /** deprecated: don't use leg, moveOrders is not used */
  moveOrdersTo (leg, flightOrders) {
    document.MeridianVue.debug && console.warn('TODO: [freight.moveOrdersTo]')
    const { flight } = this.getFlightByLeg(leg)
    flightOrders = Array.isArray(flightOrders) ? flightOrders : [flightOrders]
    const moveOrders = []
    flightOrders.forEach(flightOrder => {
      const moveOrder = flight.moveOrderTo(flightOrder)
      moveOrders.push(moveOrder)
    })
    return moveOrders
  }
  deleteRemovedOrders (removedOrdersIds) {
    document.MeridianVue.debug && console.warn('TODO: [freight.deleteRemovedOrders]')
    const orders = []
    for (let removedOrdersId of removedOrdersIds) {
      const index = this.removedOrders.findIndex(order => order.id === removedOrdersId)
      const removed = this.removedOrders.splice(index, 1)
      orders.push(...removed)
    }
    return orders
  }

  getOrders () {
    document.MeridianVue.debug && console.warn('TODO: [freight.getOrders]')
    return this.flights.reduce((acc, flight) => {
      acc.push(...flight.orders)
      return acc
    }, [])
  }

  hasProcessInstance () {
    return this.getState() !== 'NEW' && this.getState() !== 'FINISHED-FACT'
  }

  getProcessStateLabel () {
    const state = this.getState()
    return i18t.t(`freight.processState.${state}`)
  }
  getState () {
    return get(this, 'processData.freightStatus', 'NEW')
  }
  hasState (state) {
    return this.getState() === state
  }
  hasAnyState (...states) {
    return states.includes(this.getState())
  }

  getLastUpdateLabel () {
    return moment.utc(this.updateDate).format('YYYY-MM-DD HH:mm:ss')
  }

  /**
   * update id and/or version
   *
   * @param id
   * @param version
   */
  update ({id, version}) {
    this.id = id
    this.version = version
  }

  static create (flightDate, ak, bortType, bort) {
    const freight = {
      id: createUUID(),
      version: 0,
      flightDate,
      ak,
      bortType,
      bort
    }
    return Freight.assign(freight)
  }
  static assign (json) {
    // remove keys with empty values to assign non-nullable fields only
    Object.keys(json).filter(key => json[key] === null).forEach(key => delete json[key])

    const freight = Object.assign(new Freight(), json)
    freight.flights = (json.flights || []).map(flight => Flight.assign(flight))
    freight._rebuildRoute()
    return freight
  }
}

class Flight {
  leg
  uuid = createUUID()

  depPortId
  arrPortId

  info = {
    time: null,
  }

  orders = []
  newOrders = []
  deleteOrders = []
  moveOrders = []

  getLegLabel () {
    return `${this.depPortLabels.code} - ${this.arrPortLabels.code}`
  }

  getOrder (flightOrderId) {
    document.MeridianVue.debug && console.warn('TODO: [flight.getOrder]')
    const index = this.orders.findIndex(order => order.id === flightOrderId)
    const order = this.orders[index]
    return { order, index }
  }

  addNewOrder (flightOrder) {
    document.MeridianVue.debug && console.warn('TODO: [flight.addNewOrder]')
    flightOrder.isNew = true
    flightOrder.flightUuid = this.uuid
    this.orders.push(flightOrder)
    this.newOrders.push(flightOrder.id)
    return flightOrder
  }

  removeOrder (flightOrderId) {
    document.MeridianVue.debug && console.warn('TODO: [flight.removeOrder]')
    const { order, index } = this.getOrder(flightOrderId)
    if (!order) {
      return null
    }

    const idIndex = this.newOrders.findIndex(id => id === flightOrderId)
    const isNew = idIndex >= 0
    if (isNew) {
      document.MeridianVue.debug && console.warn('just remove from orders and newOrders')
      // just remove from orders and newOrders (id)
      this.orders.splice(index, 1)
      this.newOrders.splice(idIndex, 1)
      delete order.isNew
      delete order.flightUuid
    } else {
      // TODO: remove from orders now or when update response received?
      Vue.set(order, 'isDeletePending', true)
      this.deleteOrders.push(flightOrderId)
    }
    return order
  }
  moveOrderFrom (flightOrderId) {
    document.MeridianVue.debug && console.warn('TODO: [flight.moveOrderFrom]')
    const { order, index } = this.getOrder(flightOrderId)
    if (!order) {
      return null
    }

    const idNewIndex = this.newOrders.findIndex(id => id === flightOrderId)
    const idDeleteIndex = this.deleteOrders.findIndex(id => id === flightOrderId)
    const idMoveIndex = this.moveOrders.findIndex(moveOrder => moveOrder.id === flightOrderId)
    const isNew = idNewIndex >= 0
    const isDelete = idDeleteIndex >= 0
    const isMove = idMoveIndex >= 0
    if (isDelete) {
      throw new Error('Delete orders can not be moved from one flight to another')
    }
    if (isNew) {
      // just remove from newOrders (id)
      this.newOrders.splice(idNewIndex, 1)
      // do not delete order.isNew
    }
    if (isMove) {
      // just remove from moveOrders to be added to another target's moveOrders
      this.moveOrders.splice(idMoveIndex, 1)
    }
    // just remove from orders and newOrders (id)
    this.orders.splice(index, 1)
    return order
  }
  moveOrderTo (flightOrder) {
    document.MeridianVue.debug && console.warn('TODO: [flight.moveOrderTo]')
    if (flightOrder.isNew) {
      this.addNewOrder(flightOrder)
    } else {
      const { sourceFlightUuid } = flightOrder.isMoveFromPending
      if (this.uuid === sourceFlightUuid) {
        // order was moved back to the freight before save
        document.MeridianVue.debug && console.log('order#%o was moved back before save', flightOrder.id)
        // NOTE:
      } else {
        this.moveOrders.push({id: flightOrder.id, ...flightOrder.isMoveFromPending})
      }
      flightOrder.flightUuid = this.uuid
      this.orders.push(flightOrder)
    }
    return flightOrder
  }

  static assign (flightJson) {
    const flight = Object.assign(new Flight(), flightJson)
    flight.orders = (flightJson.orders || []).map(flightOrderJson => FlightOrder.assign(flightOrderJson))
    Flight.resolveFlightPorts(flight)
    return flight
  }
  static resolveFlightPorts (flight) {
    flight.depPortLabels = resolvePortLabels(flight.depPortId)
    flight.arrPortLabels = resolvePortLabels(flight.arrPortId)
  }
}

export { Freight, Flight, AVG_PERSON_WEIGHT }



// WEBPACK FOOTER //
// ./src/models/freight.js